var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginPasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97717 10.6438V8.8041C6.97717 5.75948 7.897 3.28516 12.4961 3.28516C17.0952 3.28516 18.0151 5.75948 18.0151 8.8041V10.6438",
    stroke: "#6F767E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4961 18.4623C13.7661 18.4623 14.7957 17.4327 14.7957 16.1627C14.7957 14.8927 13.7661 13.8632 12.4961 13.8632C11.2261 13.8632 10.1965 14.8927 10.1965 16.1627C10.1965 17.4327 11.2261 18.4623 12.4961 18.4623Z",
    stroke: "#6F767E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0952 21.6817H7.89697C4.21768 21.6817 3.29785 20.7619 3.29785 17.0826V15.2429C3.29785 11.5636 4.21768 10.6438 7.89697 10.6438H17.0952C20.7745 10.6438 21.6943 11.5636 21.6943 15.2429V17.0826C21.6943 20.7619 20.7745 21.6817 17.0952 21.6817Z",
    stroke: "#6F767E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPasswordIcon);
export default __webpack_public_path__ + "static/media/loginPasswordIcon.00bf17168ed951d687df4c15a4097b7c.svg";
export { ForwardRef as ReactComponent };